export default __webpack_public_path__ + "ae04c67f77b4f3004105193ce589b94e.png";